// src/data/nom035SecIQuestions.js
import nomQuestions from "./nomQuestions";

const GENERAL_FIELDS = new Set(["email", "biologicalSex", "ageRange"]);

const isNom035SecIGuideField = (field = "") =>
  field.startsWith("seccionI_") ||
  field.startsWith("seccionII_") ||
  field.startsWith("seccionIII_") ||
  field.startsWith("seccionIV_");

const nom035SecIQuestions = nomQuestions.filter((q) => {
  const field = q?.field || "";
  return GENERAL_FIELDS.has(field) || isNom035SecIGuideField(field);
});

export default nom035SecIQuestions;
